export default __webpack_public_path__ + "static/media/5.6ab64e5f.webp";